import {
  LANDING_PAGE_LOADER,
  LANDING_PAGE_SUCCESS,
  LANDING_PAGE_FAILURE,
  LANDING_PAGE_RESET,
} from "../../constants/Home/LandingConstants";

const initialState = {
  isLoading: false,
  LandingPage: {},
  errorMessage: "",
};

export const LandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LANDING_PAGE_LOADER:
      return { ...state, isLoading: true };

    case LANDING_PAGE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        LandingPage: action.payload,
        errorMessage: "",
      };

    case LANDING_PAGE_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };

    case LANDING_PAGE_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
